export default "__VITE_ASSET__78c7c320__"